module.exports = __webpack_public_path__ + "img/license_image2.3dafaab3.png";